/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Simple accordion effect

*/

import 'bootstrap/js/collapse';

// function initAccordionContainer() {
//     $('[data-accordion-container]').each(function(){
//         var $this = $(this);
//         var $accordion_trigger = $this.find('[data-accordion-trigger');
//         var $accordion_item = $this.find('[data-accordion-item]');
//         var container_height = $container_to_expand.height();
//         $this.attr('data-height',container_height);

//         $this.on('click',function(e){
//             var $this = $(this);
//             var expanded_class = 'expanded';
//             var container_height = $container_to_expand.attr('data-height');
//             e.preventDefault();
//             // toggle container visibility
//             if($container_to_expand.hasClass(expanded_class)) {
//                 $container_to_expand.css('height','');
//                 $container_to_expand.removeClass(expanded_class);
//             }else {
//                 $container_to_expand.css('height',container_height);
//                 $container_to_expand.addClass(expanded_class);
//             }
//             // toggle button visibility
//             $('.toggle-lawyer-summary').toggle();
//         });
//     });
// }

// initAccordionContainer();

// // re-calculate container height
// $(window).on('resize',function(){
//     initAccordionContainer();
// });



// WEBPACK FOOTER //
// ./static/js/modules/accordion.js